import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { voucherStatus } from "@/lib/api";

const trackPixel = (event, params = {}) => {
    if (typeof window !== "undefined" && window.fbq) window.fbq("track", event, params);
};

export default function VoucherSuccess() {
    const [searchParams] = useSearchParams();
    const sid = searchParams.get("sid");
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sid) { setError("Missing session_id"); return; }
        let cancelled = false;
        const poll = async () => {
            try {
                const r = await voucherStatus(sid);
                if (cancelled) return;
                if (r.status === "pending") {
                    if (attempts < 12) {
                        setTimeout(() => setAttempts(a => a + 1), 2000);
                    } else {
                        setError("Voucher in elaborazione — controlla la mail tra qualche minuto");
                    }
                    return;
                }
                setData(r);
                trackPixel("Purchase", { value: (r.amount_cents || 0) / 100, currency: "EUR", content_type: "gift_voucher" });
            } catch {
                if (!cancelled) setError("Errore recupero voucher");
            }
        };
        poll();
        return () => { cancelled = true; };
    }, [sid, attempts]);

    return (
        <div className="min-h-screen bg-[#0a0b0d] text-[#F4F2ED] flex flex-col" data-testid="page-voucher-success">
            <header className="border-b-4 border-[#E2231A]">
                <div className="max-w-4xl mx-auto px-5 md:px-8 py-6">
                    <a href="/" className="hover:opacity-80 transition"><img src="/logo/velora-horizontal.png" alt="VELORA JDM" className="h-8 md:h-10" /></a>
                </div>
            </header>

            <main className="flex-1 max-w-2xl mx-auto px-5 md:px-8 py-12 w-full">
                {error && (
                    <div className="text-center py-10">
                        <div className="text-4xl mb-4">⚠</div>
                        <div className="text-lg mb-2">{error}</div>
                        <a href="/" className="text-[#E2231A] uppercase tracking-widest text-sm hover:underline">Torna alla home</a>
                    </div>
                )}
                {!error && !data && (
                    <div className="text-center py-16">
                        <div className="animate-spin w-12 h-12 border-4 border-[#E2231A] border-t-transparent rounded-full mx-auto mb-4"></div>
                        <div className="text-sm text-[#9AA2AD] uppercase tracking-widest">Preparo il tuo voucher…</div>
                    </div>
                )}
                {data && (
                    <>
                        <div className="text-center mb-8">
                            <div className="text-5xl mb-4">🎁</div>
                            <h1 className="font-display text-3xl md:text-5xl uppercase mb-2">Voucher creato!</h1>
                            <p className="text-[#9AA2AD]">Abbiamo inviato tutto via email{data.recipient_name ? ` a te e a ${data.recipient_name}` : ""}.</p>
                        </div>

                        <div className="bg-gradient-to-br from-[#15181C] via-[#1a0708] to-[#15181C] border-2 border-[#E2231A] p-6 md:p-8 mb-6" data-testid="voucher-card">
                            <div className="flex justify-between items-start mb-6 flex-wrap gap-2">
                                <div>
                                    <img src="/logo/velora-horizontal.png" alt="VELORA JDM" className="h-9 mb-1" />
                                    <div className="text-[10px] uppercase tracking-widest text-[#9AA2AD]">Cofanetto Regalo</div>
                                </div>
                                <div className="text-right">
                                    <div className="text-[10px] uppercase tracking-widest text-[#9AA2AD]">Valore</div>
                                    <div className="font-display text-3xl text-[#E2231A]">€{data.amount_cents / 100}</div>
                                </div>
                            </div>
                            <div className="text-center py-6 my-4 bg-[#E2231A] text-[#F4F2ED]">
                                <div className="text-[10px] uppercase tracking-widest opacity-80 mb-2">CODICE VOUCHER</div>
                                <div className="font-display text-3xl md:text-4xl tracking-[0.3em]" data-testid="voucher-code">{data.code}</div>
                            </div>
                            <div className="text-xs text-center text-[#9AA2AD] mt-4">
                                Valido fino al {(data.expires_at || "").slice(0, 10)} · Riscattabile una sola volta
                            </div>
                        </div>

                        <div className="border border-[#16a34a]/30 bg-[#16a34a]/5 p-5 text-sm mb-6">
                            <div className="font-display text-sm uppercase tracking-widest mb-2 text-[#16a34a]">Prossimi passi</div>
                            <ol className="list-decimal list-inside space-y-1 text-[#c8ccd1]">
                                <li>Controlla la casella email (anche spam)</li>
                                <li>Consegna il codice al destinatario</li>
                                <li>Il destinatario va su <b>velorajdm.com/riscatta</b>, inserisce il codice e sceglie la data</li>
                            </ol>
                        </div>

                        <div className="flex gap-3 flex-wrap justify-center">
                            <a href="/" className="border border-[#9AA2AD]/30 hover:border-[#F4F2ED] px-5 py-3 text-xs uppercase tracking-widest">Torna alla home</a>
                            <a href="/voucher" className="border border-[#E2231A] hover:bg-[#E2231A]/10 text-[#E2231A] px-5 py-3 text-xs uppercase tracking-widest">Compra un altro voucher</a>
                        </div>
                    </>
                )}
            </main>

            <footer className="border-t border-[#9AA2AD]/20 py-6 text-center text-xs text-[#9AA2AD]">
                VELORA JDM · Marchio di MAS S.r.l.
            </footer>
        </div>
    );
}
